import React, { useState } from "react"
import MaterialPopover from "../Popover/MaterialPopover"

function NavbarItem(props) {
    const { icon: IconComponent, name, active, children, grow = false, onClick, navbarOpen } = props

    const [open, toggle] = useState(false)

    function handleNamePress() {
        if (onClick) onClick()
        else toggle(!open)
    }

    return (
        <>
            <MaterialPopover position="right" text={name} isVisible={navbarOpen ? false : true}>
                <div className={"navbar__item" + (open ? " expanded" : "") + (active ? " active" : "")}>
                    <div className="navbar__item__content">
                        <button className="navbar__item__icon-container" onClick={handleNamePress}>
                            <div className="navbar__item__icon">{IconComponent && <IconComponent />}</div>
                        </button>
                        <button className="navbar__item__text" onClick={handleNamePress}>
                            {name}
                        </button>
                    </div>
                </div>
            </MaterialPopover>
            {open && (
                <div className={"navbar__item__children" + (grow ? " grow" : "")}>
                    <div className="navbar__item__children__container">{children}</div>
                </div>
            )}
        </>
    )
}

export default NavbarItem
